import {
  Stack,
  Button,
  Snackbar,
  SvgIconPropsColorOverrides,
} from "@mui/material";
import { useState } from "react";
import Text from "src/components/Displays/Text";
import { CopyToClipboardIcon } from "src/assets";
import { OverridableStringUnion } from "@mui/types";

interface CopyToClipboardButtonProps {
  id: string;
  message: string;
  color?:
    | OverridableStringUnion<
        | "disabled"
        | "action"
        | "inherit"
        | "primary"
        | "secondary"
        | "error"
        | "info"
        | "success"
        | "warning",
        SvgIconPropsColorOverrides
      >
    | undefined;
}

const CopyOcppUrl = ({ id, color, message }: CopyToClipboardButtonProps) => {
  const [open, setOpen] = useState(false);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setOpen(true);
    e.stopPropagation();
    navigator.clipboard.writeText(id);
  };

  return (
    <>
      <Button aria-label="ocpp-url-copy" onClick={handleClick}>
        <Stack
          gap={2}
          direction={"row"}
          alignItems={"center"}
          sx={{
            border: "1px solid lightgray",
            width: "fit-content",
            borderRadius: "32px",
            px: 4,
            py: 1,
            "&:hover": {
              backgroundColor: "#ffffff",
            },
          }}
        >
          <Text
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "bold",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: theme.palette.mainFont.primary,
            })}
            text={"OCPP-URL kopieren"}
          />
          <CopyToClipboardIcon />
        </Stack>
      </Button>

      <Snackbar
        open={open}
        message={message}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        ContentProps={{
          sx: {
            display: "block",
            textAlign: "center",
          },
        }}
      />
    </>
  );
};

export default CopyOcppUrl;
